<template>
  <!-- 我的评价 -->
  <div class="evaluate">
    <div class="tabbar">
      <el-button
        type="primary"
        size="medium"
        v-for="(item, index) in category"
        :key="index"
        :plain="index != categoryIndex"
        @click="changeTable(index)"
        >{{ item }}</el-button
      >
    </div>
    <div class="table" v-show="categoryIndex == 0">
      <el-table :data="tableData" stripe>
        <el-table-column
          type="index"
          align="center"
          label="序号"
          :index="count"
          width="100"
        ></el-table-column>
        <el-table-column
          align="left"
          label="订单信息"
          width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div
              style="display: flex;align-items: center;justify-content: flex-start;"
            >
              <img
                :src="$imgUrl + scope.row.pictureUrl"
                alt=""
                style="width: 30px;height: 30px;margin-right: 10px;"
              />
              <span>{{ scope.row.orderNo }}</span>
            </div>
          </template>
        </el-table-column>
          <el-table-column label="工程名称" align="center" prop="projectname" />
        <el-table-column align="left" label="评价用户">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;">
              <img
                :src="$imgUrl + scope.row.heading"
                alt=""
                style="width: 30px;height: 30px;margin-right: 10px;"
                alt=""
              />
              <span>{{ scope.row.masterName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" prop="addTime"></el-table-column>
        <el-table-column
          label="订单类型"
          align="center"
          prop="orderType"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="medium"
              plain
              @click="jump(scope.row)"
              >回复</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right;margin-top: 20px;"
        @current-change="pageNumChange"
        :current-page="page.pageNum"
        :page-size="page.pageSize"
        layout="prev, pager, next,total"
        :total="page.total"
        background
      >
      </el-pagination>
    </div>
    <div class="table" v-show="categoryIndex == 1">
      <el-table :data="tableData" stripe>
        <el-table-column
          type="index"
          align="center"
          label="序号"
          :index="count"
          width="100"
        ></el-table-column>
        <el-table-column align="left" label="订单信息" width="300">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;">
              <img
                :src="$imgUrl + scope.row.pictureUrl"
                alt=""
                style="width: 30px;height: 30px;margin-right: 10px;"
              />
              <span>{{ scope.row.title }}</span>
            </div>
          </template>
        </el-table-column>
          <el-table-column label="工程名称" align="center" prop="projectname" />
        <el-table-column align="left" label="评价用户">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;">
              <img
                :src="$imgUrl + scope.row.heading"
                alt=""
                style="width: 30px;height: 30px;margin-right: 10px;"
              />
              <span>{{ scope.row.masterName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单时间" prop="addTime"></el-table-column>
        <el-table-column
          label="订单类型"
          align="center"
          prop="orderType"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="medium"
              plain
              @click="jump(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: right;margin-top: 20px;"
        @current-change="pageNumChange"
        :current-page="page.pageNum"
        :page-size="page.pageSize"
        layout="prev, pager, next,total"
        :total="page.total"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { pingjiaListApi } from "../../http/factory/add-eme.js";
export default {
  name: "evaluate",
  data() {
    return {
      category: ["未回复", "已回复"],
      categoryIndex: 0,
      tableData: [],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      reply: 1,
    };
  },
  created() {
    this.getList(this.reply);
  },
  methods: {
    handleCurrentChange(index) {
      console.log(index);
    },
    count(index) {
      return (this.page.pageNum - 1) * this.page.pageSize + index + 1;
    },
    pageNumChange(val) {
      this.page.pageNum = val;
      this.getList(this.reply);
    },
    getList(reply) {
      pingjiaListApi({
        reply: this.reply,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNum,
      }).then((res) => {
        this.tableData = res.rows;
        for (let item of this.tableData) {
          item.eqList = JSON.parse(item.equipmentList);
          if (
            !item.pictureUrl &&
            item.eqList &&
            item.eqList.length > 0 &&
            item.eqList[0].pictureUrl
          ) {
            item.pictureUrl = item.eqList[0].pictureUrl;
          }
          item.orderType == 0
            ? (item.orderType = "成套")
            : (item.orderType = "保电");
        }
        this.page.total = res.total;
      });
    },
    jump(row) {
      this.$router.push({
        path:
          row.orderType == "成套"
            ? "/factoryUser/factoryDetailEqu"
            : "/factoryUser/factoryDetailEme",
        query: {
          id: row.id,
        },
      });
    },
    // 更换表格
    changeTable(index) {
      if (index == 0) {
        this.reply = 1;
      } else {
        this.reply = 2;
      }
      this.categoryIndex = index;
      this.getList(this.reply);
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList(this.reply);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.evaluate {
  width: 100%;
  background: @vue-bg-color;

  .tabbar {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: flex-end;
    padding: 0px @vue-spacing-row-base;
    box-sizing: border-box;
  }

  .table {
    margin: 0 auto;
    width: 96%;
    height: 810px;
  }
}
</style>
